var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary"}},[_c('b-card',[_c('ubicacionesForm',{attrs:{"ubicacion":_vm.ubicacionData,"ubicacionSubmit":"Crear Ubicación"},on:{"processUbicacion":_vm.agregarUbicacion}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }